import { HourglassHigh } from '@phosphor-icons/react';

export default HourglassHigh;